import { Stack, Typography } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors'
import { PushPin } from '@mui/icons-material'
import DoneIcon from '@mui/icons-material/Done'
import { useEffect } from 'react'

const JobEventItem = ({ event, isFamily, isFamilyViewActive, currentLevel, parentLevel }) => {
  useEffect(() => {
    if (!isFamily && isFamilyViewActive && event.backgroundColor !== '#8f8f8f') {
      event.setProp('color', '#8f8f8f')
    }
  }, [isFamily, isFamilyViewActive, event])
  return (
    <Stack direction='row' justifyContent='center'>
      <Stack
        sx={{
          height: '3rem',
          overflowX: 'hidden',
          background: event.extendedProps.late || event.extendedProps.done ? 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.25) 50%, rgba(255,255,255,0) 100%)' : null
        }}
        direction='row'
        justifyContent='center'
      >
        {event.extendedProps.done
          ? (
            <DoneIcon sx={{ height: '100%', width: 'auto' }} color='success' />
            )
          : (
            <>
              {event.extendedProps.late && <WarningIcon sx={{ height: '100%', width: 'auto' }} color='error' />}
            </>
            )}
        {event.extendedProps.infiniteLoad && (
          <RunningWithErrorsIcon sx={{ height: '100%', width: 'auto' }} color='error' />
        )}
        {isFamilyViewActive && currentLevel != null && Number.isFinite(currentLevel) && (
          <Typography
            sx={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              fontWeight: 'bold',
              fontSize: '0.8rem',
              color: 'black',
              backgroundColor: '#e4e0e0',
              padding: '2px 4px',
              borderRadius: '3px'
            }}
          >
            {currentLevel}
          </Typography>
        )}
        {isFamilyViewActive && parentLevel != null && Number.isFinite(parentLevel) && (
          <Typography
            sx={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              fontWeight: 'bold',
              fontSize: '0.8rem',
              backgroundColor: '#e4e0e0',
              color: 'black',
              padding: '2px 4px',
              borderRadius: '80%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '20px',
              height: '20px'
            }}
          >
            {parentLevel}
          </Typography>
        )}
      </Stack>
      {/* Story 96 (CA10/RN28/RN29/INV6): the date pin is the ONLY criterion of the pin icon. The
          per-task machine pin is retired, and a job's preferred machine deliberately does not paint
          here -- it is job data, not a plan pin, and is only visible in the dialog's "Job Settings"
          tab (D6). */}
      {!event.extendedProps.done && event.extendedProps.pinnedDate
        ? (
          <PushPin sx={{ height: '1.2rem', width: '1.2rem', marginTop: '5px' }} color='action' />
          )
        : null}
    </Stack>
  )
}

export default JobEventItem
